import api from "../client";

/* =========================
   AUTH
========================= */

export const signup = (
  payload
) =>
  api.post(
    "/client-auth/signup",
    payload
  );

export const login = (
  payload
) =>
  api.post(
    "/client-auth/login",
    payload
  );

export const refresh = (payload) =>
  api.post(
    "/client-auth/refresh",payload
  );

export const me = () =>
  api.get(
    "/client-auth/me"
  );

export const logout = () =>
  api.post(
    "/client-auth/logout"
  );

export const logoutAll = () =>
  api.post(
    "/client-auth/logout-all"
  );

export const changePassword = (
  payload
) =>
  api.post(
    "/client-auth/change-password",
    payload
  );

export const updateProfile = (
  payload
) =>
  api.patch(
    "/client-auth/profile",
    payload
  );